import {logSentry} from '@/lib/sentry';
import {useSettingsQuery} from '@/framework/gql/settings.graphql';

// Default locale — single-locale site (vi). Avoids dependency on next/router
// which is not available in App Router.
const DEFAULT_LOCALE = process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE ?? 'vi';

export function useSettings() {
    const locale = DEFAULT_LOCALE;

    try {
        const {
            data,
            loading: isLoading,
            error,
        } = useSettingsQuery({
            variables: {
                language: locale ?? 'vi',
            },
        });

        return {
            settings: data?.settings?.options ?? {},
            isLoading,
            error,
        };
    } catch (err) {
        logSentry({
            error: err as Error,
            name: 'settings',
            transactionName: 'useSettingsQuery',
        });
        return {
            settings: {},
            isLoading: false,
            error: err,
        };
    }
}
